import React, { useCallback } from "react";
import { Home, Biography, Gallery, Contact, Footer } from "layout";
import { useSelector } from "react-redux";
import Scroll from "react-scroll"
import LanguageToolbar from "./toolbars/LanguagesToolbar";

var Link = Scroll.Link;
var Element = Scroll.Element;

const App = () => {

  const { navigation } = useSelector((state) => state.content);
  const memorizeActivateBurgerMenu = useCallback(() => {
    var x = document.getElementById("top-navigation-bar");
    if (x.className === "topnav") {
      x.className += " responsive";
    }
    else x.className = "topnav";
  }, []);

  return (
    <div>
      <div id="scroll-container">
        <div className="topnav" id="top-navigation-bar">
          <i
            className="fa fa-bars fa-2x icon"
            onClick={memorizeActivateBurgerMenu}
          />
          <Link
            containerId="scroll-container"
            activeClass="active"
            to="home"
            spy={true}
            hashSpy={true}
            duration={300}
            saveHashHistory={false}
            smooth={true}
          >
            {navigation.home}
          </Link>
          <Link
            containerId="scroll-container"
            activeClass="active"
            to="biography"
            spy={true}
            hashSpy={true}
            duration={300}
            smooth={true}
          >
            {navigation.biography}
          </Link>
          <Link
            containerId="scroll-container"
            activeClass="active"
            to="gallery"
            spy={true}
            hashSpy={true}
            duration={300}
            smooth={true}
          >
            {navigation.gallery}
          </Link>
          <Link
            containerId="scroll-container"
            activeClass="active"
            to="contact"
            spy={true}
            hashSpy={true}
            duration={300}
            smooth={true}
          >
            {navigation.contact}
          </Link>
          <LanguageToolbar />
        </div>

        <div className="sections-flex-container">
          <Element
            name="home"
            className="section home"

          >
            <Home />
          </Element>
          <Element
            name="services"
            className="section biography"

          >
            <Biography />
          </Element>
          <Element
            name="gallery"
            className="section gallery"
          >
            <Gallery />
          </Element>
          <Element
            name="contact"
            className="section contact"
          >
            <Contact />
          </Element>

          <Footer />
        </div>
      </div>
    </div>
  );
};

export default App;
